// frontend/src/components/ChatBubble.tsx
import React from 'react';
import Button from 'react-bootstrap/Button';
import { ChatDots } from 'react-bootstrap-icons'; // Icono de chat

interface ChatBubbleProps {
  onClick: () => void; // Función a llamar al hacer clic
}

// Estilos básicos inline (puedes moverlos a CSS)
const bubbleStyle: React.CSSProperties = {
  position: 'fixed',
  bottom: '20px',
  left: '20px', // Posición inferior izquierda
  zIndex: 1050, // Asegurar que esté sobre otros elementos base
  borderRadius: '50%', // Hacerlo redondo
  width: '60px',
  height: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 4px 8px rgba(0,0,0,0.2)' // Sombra
};

export function ChatBubble({ onClick }: ChatBubbleProps) {
  return (
    <Button
      variant="primary" // O el color que prefieras
      style={bubbleStyle}
      onClick={onClick}
      aria-label="Abrir chat"
    >
      <ChatDots size={24} /> {/* Icono */}
    </Button>
  );
}